/*eslint no-undef: "error"*/
<template>
    <div>
      <gmap-map :center="center" ref="myMapService" :options="{streetViewControl: false}" :zoom="zoom" class="sinNav">
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" :content="infoContent" @closeclick="infoWinOpen=false"></gmap-info-window>
        <gmap-marker
        :key="i"
        v-for="(m, i) in markers"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      <gmap-marker
        :key="i + 'mensajero'"
        v-for="(m, i) in mensajeros"
        :position="m.position"
        :icon="m.icon"
        @click="toggleInfoWindow(m,i)"
      ></gmap-marker>
      </gmap-map>
    </div>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import router from '../router'
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash'
import { loaded } from 'vue2-google-maps'
export default {
  name: 'servicio',
  data () {
    return {
      nav: {
        edge: 'right'
      },
      GET_SERVICE_URL: 'https://mensajeria.guepardos.co/api/v2/services/',
      Url_Mensajeros: 'https://mensajeria.guepardos.co/api/v2/messengersPositions',
      interval: '',
      center: {
        lat: 6.2269243,
        lng: -75.5682957
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      },
      zoom: 13,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      mensajeros: [],
      servicios: [],
      user: {}
    }
  },
  beforeCreate () {
    http.get(`servicesUser/${this.$route.params.id}`)
    .then(res => {
      this.servicios = res.data
      if (_.size(this.servicios) === 0) {
        this.dibujarDireccion()
      } else {
        this.dibujarServicios()
        this.dibujarMensajeros()
      }
    })
    this.interval = setInterval(function () {
      http.get(`servicesUser/${this.$route.params.id}`)
      .then(res => {
        if (_.size(this.servicios) === 0) {
          this.dibujarDireccion()
        } else {
          this.dibujarServicios()
          this.dibujarMensajeros()
        }
      })
    }.bind(this), 10000)
  },
  mounted () {
    let vm = this
    loaded.then(() => {
      this.$refs.myMapService.$mapCreated.then(() => {
        const src = 'http://storage.googleapis.com/gpds-geo-zonas/AreaMetroMensajeriaMapa.kml'
        let kmlLayer = new google.maps.KmlLayer(src, {
          suppressInfoWindows: true,
          preserveViewport: true,
          map: vm.$refs.myMapService.$mapObject
        })
      })
    })
  },
  methods: {
    dibujarServicios () {
      _.forEach(this.servicios, element => {
        this.markers.push({
          position: {
            lat: parseFloat(element.geoR.lat),
            lng: parseFloat(element.geoR.lng)
          },
          infoText: `${element.descripcion} - ${element.recogida}`,
          icon: require('../assets/home.png')
        })
        this.dibujarEntregas(element.fechaHoraEntregas, element.recogida, element.mensajero.nombre)
      })
    },
    dibujarEntregas (entregas, servicio, mensajero) {
      _.forEach(entregas, (entrega, index) => {
        this.markers.push({
          position: {
            lat: entrega.coordenadas.latitude,
            lng: entrega.coordenadas.longitude
          },
          infoText: `Entrega ${index + 1} - servicio: ${servicio} - mensajero: ${mensajero}`,
          icon: require('../assets/entrega.png')
        })
      })
    },
    dibujarMensajeros () {
      _.forEach(this.servicios, element => {
        this.mensajeros.push({
          position: {
            lat: parseFloat(element.ultimaPosicion[0].point.lat),
            lng: parseFloat(element.ultimaPosicion[0].point.lng)
          },
          infoText: `${element.mensajero.nombre} - Placa: ${element.mensajero.placa} - Celular: ${element.mensajero.celular}`,
          icon: require('../assets/mensajero.png')
        })
      })
    },
    dibujarDireccion () {
      http.get(`userData/${this.$route.params.id}`)
      .then(res => {
        this.user = res.data
        this.markers.push({
          position: {
            lat: parseFloat(this.user.geo.lat),
            lng: parseFloat(this.user.geo.lng)
          },
          infoText: `Mi Dirección`,
          icon: require('../assets/home.png')
        })
        this.center = {
          lat: parseFloat(this.user.geo.lat),
          lng: parseFloat(this.user.geo.lng)
        }
        this.zoom = 14
      })
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>
<style>
.side-nav {
  position: fixed;
  width: 300px;
  left: 0;
  top: 0;
  margin: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
  height: 100%;
  height: calc(100% + 60px);
  height: -moz-calc(100%);
  padding-bottom: 60px;
  background-color: #fff;
  z-index: 999;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  overflow-y: auto;
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateX(-105%);
  transform: translateX(-105%);
}
.marker {
  float: right;
  position: relative;
  padding-right: 5px;
  z-index: 1;
}
.sizeA {
  color: #410099;
}
.gm-fullscreen-control {
  display: none;
}
.colorVerde {
    color: #5cb85c;
}
.conNav {
 height: 91vh;
}
.sinNav {
  height: 100vh;
}
.stroke {
  -webkit-text-stroke: 0.5px black;
  opacity: 0.8;
}
.purple.darken-4 {
    background-color: #410099 !important;
}
.labels{
    color: black;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    width: 100px;
}
</style>



// WEBPACK FOOTER //
// Servicios.vue?4f100768